const propertyActions = {

  DO2_LIST_PROPERTIES: 'DO2_LIST_PROPERTIES',
  DO2_LIST_PROPERTIES_SUCCEEDED: 'DO2_LIST_PROPERTIES_SUCCEEDED',
  DO2_LIST_PROPERTIES_FAILED: 'DO2_LIST_PROPERTIES_FAILED',
  doListProperties: () => ({
    type: propertyActions.DO2_LIST_PROPERTIES
  }),
  doListPropertiesSucceeded: response => ({
    type: propertyActions.DO2_LIST_PROPERTIES_SUCCEEDED,
    payload: response
  }),
  doListPropertiesFailed: response => ({
    type: propertyActions.DO2_LIST_PROPERTIES_FAILED,
    payload: response
  }),

  DO2_GET_PROPERTY: 'DO2_GET_PROPERTY',
  DO2_GET_PROPERTY_SUCCEEDED: 'DO2_GET_PROPERTY_SUCCEEDED',
  DO2_GET_PROPERTY_FAILED: 'DO2_GET_PROPERTY_FAILED',
  doGetProperty: (hash, includedDetails) => ({
    type: propertyActions.DO2_GET_PROPERTY,
    hash,
    includedDetails: includedDetails || []
  }),
  doGetPropertySucceeded: response => ({
    type: propertyActions.DO2_GET_PROPERTY_SUCCEEDED,
    payload: response
  }),
  doGetPropertyFailed: response => ({
    type: propertyActions.DO2_GET_PROPERTY_FAILED,
    payload: response
  }),

  DO2_ADD_PROPERTY: 'DO2_ADD_PROPERTY',
  DO2_ADD_PROPERTY_SUCCEEDED: 'DO2_ADD_PROPERTY_SUCCEEDED',
  DO2_ADD_PROPERTY_FAILED: 'DO2_ADD_PROPERTY_FAILED',
  DO2_ADD_PROPERTY_RESET: 'DO2_ADD_PROPERTY_RESET',
  doAddProperty: response => ({
    type: propertyActions.DO2_ADD_PROPERTY,
    payload: response
  }),
  doAddPropertySucceeded: response => ({
    type: propertyActions.DO2_ADD_PROPERTY_SUCCEEDED,
    payload: response
  }),
  doAddPropertyFailed: response => ({
    type: propertyActions.DO2_ADD_PROPERTY_FAILED,
    payload: response
  }),
  doAddPropertyReset: () => ({
    type: propertyActions.DO2_ADD_PROPERTY_RESET
  }),

  DO2_UPDATE_PROPERTY: 'DO2_UPDATE_PROPERTY',
  DO2_UPDATE_PROPERTY_SUCCEEDED: 'DO2_UPDATE_PROPERTY_SUCCEEDED',
  DO2_UPDATE_PROPERTY_FAILED: 'DO2_UPDATE_PROPERTY_FAILED',
  DO2_UPDATE_PROPERTY_RESET: 'DO2_UPDATE_PROPERTY_RESET',  
  doUpdateProperty: (updateType, payload, reloadExtras = false) => ({
    type: propertyActions.DO2_UPDATE_PROPERTY,
    updateType,
    payload,
    reloadExtras
  }),
  doUpdatePropertySucceeded: (updateType, response) => ({
    type: propertyActions.DO2_UPDATE_PROPERTY_SUCCEEDED,
    updateType,
    payload: response
  }),
  doUpdatePropertyFailed: (updateType, response) => ({
    type: propertyActions.DO2_UPDATE_PROPERTY_FAILED,
    updateType,
    payload: response
  }),
  doUpdatePropertyReset: () => ({
    type: propertyActions.DO2_UPDATE_PROPERTY_RESET
  }),

  DO2_UPDATE_HMO: 'DO2_UPDATE_HMO',
  DO2_UPDATE_HMO_SUCCEEDED: 'DO2_UPDATE_HMO_SUCCEEDED',
  DO2_UPDATE_HMO_FAILED: 'DO2_UPDATE_HMO_FAILED',
  DO2_UPDATE_HMO_RESET: 'DO2_UPDATE_HMO_RESET',
  doUpdateHmo: (payload) => ({
    type: propertyActions.DO2_UPDATE_HMO,
    payload,
  }),
  doUpdateHmoSucceeded: (response) => ({
    type: propertyActions.DO2_UPDATE_HMO_SUCCEEDED,
    payload: response,
  }),
  doUpdateHmoFailed: (response) => ({
    type: propertyActions.DO2_UPDATE_HMO_FAILED,
    payload: response,
  }),
  doUpdateHmoReset: () => ({
    type: propertyActions.DO2_UPDATE_HMO_RESET,
  }),

  DO2_DELETE_PROPERTY: 'DO2_DELETE_PROPERTY',
  DO2_DELETE_PROPERTY_SUCCEEDED: 'DO2_DELETE_PROPERTY_SUCCEEDED',
  DO2_DELETE_PROPERTY_FAILED: 'DO2_DELETE_PROPERTY_FAILED',

  DO2_RESET_PROPERTY: 'DO2_RESET_PROPERTY',
  doResetProperty: () => ({
    type: propertyActions.DO2_RESET_PROPERTY
  }),

  DO2_POSTCODE_LOOKUP: 'DO2_POSTCODE_LOOKUP',
  DO2_POSTCODE_LOOKUP_SUCCEEDED: 'DO2_POSTCODE_LOOKUP_SUCCEEDED',
  DO2_POSTCODE_LOOKUP_FAILED: 'DO2_POSTCODE_LOOKUP_FAILED',
  doPostcodeLookup: payload => ({
    type: propertyActions.DO2_POSTCODE_LOOKUP,
    payload
  }),
  doPostcodeLookupSucceeded: response => ({
    type: propertyActions.DO2_POSTCODE_LOOKUP_SUCCEEDED,
    payload: response
  }),
  doPostcodeLookupFailed: response => ({
    type: propertyActions.DO2_POSTCODE_LOOKUP_FAILED,
    payload: response
  }),

  DO2_RESET_POSTCODE_LOOKUP: 'DO2_RESET_POSTCODE_LOOKUP',
  DO2_RESET_POSTCODE_LOOKUP_FAILED_DATA: 'DO2_RESET_POSTCODE_LOOKUP_FAILED_DATA',
  doResetPostcodeLookup: () => ({
    type: propertyActions.DO2_RESET_POSTCODE_LOOKUP
  }),
  doResetPostcodeLookupFailedData: () => ({
    type: propertyActions.DO2_RESET_POSTCODE_LOOKUP_FAILED_DATA
  }),

  DO2_HMO_LOOKUP: 'DO2_HMO_LOOKUP',
  DO2_HMO_LOOKUP_SUCCEEDED: 'DO2_HMO_LOOKUP_SUCCEEDED',
  DO2_HMO_LOOKUP_FAILED: 'DO2_HMO_LOOKUP_FAILED',
  DO2_HMO_LOOKUP_RESET: 'DO2_HMO_LOOKUP_RESET',
  doHmoLookup: payload => ({
    type: propertyActions.DO2_HMO_LOOKUP,
    payload
  }),
  doHmoLookupSucceeded: response => ({
    type: propertyActions.DO2_HMO_LOOKUP_SUCCEEDED,
    payload: response
  }),
  doHmoLookupFailed: response => ({
    type: propertyActions.DO2_HMO_LOOKUP_FAILED,
    payload: response
  }),
  doHmoLookupReset: () => ({
    type: propertyActions.DO2_HMO_LOOKUP_RESET,
  }),
  
  DO2_EPC_LOOKUP: 'DO2_EPC_LOOKUP',
  DO2_EPC_LOOKUP_SUCCEEDED: 'DO2_EPC_LOOKUP_SUCCEEDED',
  DO2_EPC_LOOKUP_FAILED: 'DO2_EPC_LOOKUP_FAILED',
  doEpcLookup: propertyHash => ({
    type: propertyActions.DO2_EPC_LOOKUP,
    payload: propertyHash
  }),
  doEpcLookupSucceeded: response => ({
    type: propertyActions.DO2_EPC_LOOKUP_SUCCEEDED,
    payload: response
  }),
  doEpcLookupFailed: response => ({
    type: propertyActions.DO2_EPC_LOOKUP_FAILED,
    payload: response
  }),

  DO2_LIST_PROPERTY_IMAGES: 'DO2_LIST_PROPERTY_IMAGES',
  DO2_LIST_PROPERTY_IMAGES_SUCCEEDED: 'DO2_LIST_PROPERTY_IMAGES_SUCCEEDED',
  DO2_LIST_PROPERTY_IMAGES_FAILED: 'DO2_LIST_PROPERTY_IMAGES_FAILED',
  doListPropertyImages: response => ({
    type: propertyActions.DO2_LIST_PROPERTY_IMAGES,
    payload: response
  }),
  doListPropertyImagesSucceeded: response => ({
    type: propertyActions.DO2_LIST_PROPERTY_IMAGES_SUCCEEDED,
    payload: response
  }),
  doListPropertyImagesFailed: response => ({
    type: propertyActions.DO2_LIST_PROPERTY_IMAGES_FAILED,
    payload: response
  }),

  DO2_ORDER_PROPERTY_IMAGES: 'DO2_ORDER_PROPERTY_IMAGES',
  DO2_ORDER_PROPERTY_IMAGES_SUCCEEDED: 'DO2_ORDER_PROPERTY_IMAGES_SUCCEEDED',
  DO2_ORDER_PROPERTY_IMAGES_FAILED: 'DO2_ORDER_PROPERTY_IMAGES_FAILED',
  doOrderPropertyImages: response => ({
    type: propertyActions.DO2_ORDER_PROPERTY_IMAGES,
    payload: response
  }),
  doOrderPropertyImagesSucceeded: response => ({
    type: propertyActions.DO2_ORDER_PROPERTY_IMAGES_SUCCEEDED,
    payload: response
  }),
  doOrderPropertyImagesFailed: response => ({
    type: propertyActions.DO2_ORDER_PROPERTY_IMAGES_FAILED,
    payload: response
  }),

  DO2_DELETE_PROPERTY_IMAGE: 'DO2_DELETE_PROPERTY_IMAGE',
  DO2_DELETE_PROPERTY_IMAGE_SUCCEEDED: 'DO2_DELETE_PROPERTY_IMAGE_SUCCEEDED',
  DO2_DELETE_PROPERTY_IMAGE_FAILED: 'DO2_DELETE_PROPERTY_IMAGE_FAILED',
  doDeletePropertyImage: payload => ({
    type: propertyActions.DO2_DELETE_PROPERTY_IMAGE,
    payload: payload
  }),
  doDeletePropertyImageSucceeded: response => ({
    type: propertyActions.DO2_DELETE_PROPERTY_IMAGE_SUCCEEDED,
    payload: response
  }),
  doDeletePropertyImageFailed: response => ({
    type: propertyActions.DO2_DELETE_PROPERTY_IMAGE_FAILED,
    payload: response
  }),

  DO2_UPLOAD_PROPERTY_DOCUMENT: 'DO2_UPLOAD_PROPERTY_DOCUMENT',
  DO2_UPLOAD_PROPERTY_DOCUMENT_SUCCESS: 'DO2_UPLOAD_PROPERTY_DOCUMENT_SUCCESS',
  DO2_UPLOAD_PROPERTY_DOCUMENT_FAILED: 'DO2_UPLOAD_PROPERTY_DOCUMENT_FAILED',
  DO2_REMOVE_PROPERTY_DOCUMENT: 'DO2_REMOVE_PROPERTY_DOCUMENT',
  doUploadPropertyDocument: payload => ({
    type: propertyActions.DO2_UPLOAD_PROPERTY_DOCUMENT,
    payload
  }),
  doUploadPropertyDocumentSuccess: response => ({
    type: propertyActions.DO2_UPLOAD_PROPERTY_DOCUMENT_SUCCESS,
    payload: response
  }),
  doUploadPropertyDocumentFailed: response => ({
    type: propertyActions.DO2_UPLOAD_PROPERTY_DOCUMENT_FAILED,
    payload: response
  }),
  doRemovePropertyDocument: response => ({
    type: propertyActions.DO2_REMOVE_PROPERTY_DOCUMENT,
    payload: response
  }),

  DO2_RENTAL_DATA_CHANGED: 'DO2_RENTAL_DATA_CHANGED',
  onRentalDataChanged: (e) => {
    return ({
      type: propertyActions.DO2_RENTAL_DATA_CHANGED,
      payload: e.target,
    });
  },

  DO2_GET_RENTAL_DATA: 'DO2_GET_RENTAL_DATA',
  DO2_GET_RENTAL_DATA_SUCCEEDED: 'DO2_GET_RENTAL_DATA_SUCCEEDED',
  DO2_GET_RENTAL_DATA_FAILED: 'DO2_GET_RENTAL_DATA_FAILED',
  doGetRentalData: (hash) => ({
    type: propertyActions.DO2_GET_RENTAL_DATA,
    hash,
  }),
  doGetRentalDataSucceeded: response => ({
    type: propertyActions.DO2_GET_RENTAL_DATA_SUCCEEDED,
    payload: response
  }),
  doGetRentalDataFailed: response => ({
    type: propertyActions.DO2_GET_RENTAL_DATA_FAILED,
    payload: response
  }),

  DO2_ADD_RENTAL_DATA: 'DO2_ADD_RENTAL_DATA',
  DO2_ADD_RENTAL_DATA_SUCCEEDED: 'DO2_ADD_RENTAL_DATA_SUCCEEDED',
  DO2_ADD_RENTAL_DATA_FAILED: 'DO2_ADD_RENTAL_DATA_FAILED',
  doAddRentalData: (propertyHash, values) => ({
    type: propertyActions.DO2_ADD_RENTAL_DATA,
    payload: { propertyHash, values }
  }),
  doAddRentalDataSucceeded: response => ({
    type: propertyActions.DO2_ADD_RENTAL_DATA_SUCCEEDED,
    payload: response
  }),
  doAddRentalDataFailed: response => ({
    type: propertyActions.DO2_ADD_RENTAL_DATA_FAILED,
    payload: response
  }),

  DO2_UPDATE_RENTAL_DATA: 'DO2_UPDATE_RENTAL_DATA',
  DO2_UPDATE_RENTAL_DATA_SUCCEEDED: 'DO2_UPDATE_RENTAL_DATA_SUCCEEDED',
  DO2_UPDATE_RENTAL_DATA_FAILED: 'DO2_UPDATE_RENTAL_DATA_FAILED',
  doUpdateRentalData: (values) => ({
    type: propertyActions.DO2_UPDATE_RENTAL_DATA,
    payload: values
  }),
  doUpdateRentalDataSucceeded: (response, shouldGetRentalData) => ({
    type: propertyActions.DO2_UPDATE_RENTAL_DATA_SUCCEEDED,
    payload: response,
    shouldGetRentalData
  }),
  doUpdateRentalDataFailed: response => ({
    type: propertyActions.DO2_UPDATE_RENTAL_DATA_FAILED,
    payload: response,
  }),

  DO2_GET_PROPERTY_RENTAL_TENANTS: 'DO2_GET_PROPERTY_RENTAL_TENANTS',
  DO2_GET_PROPERTY_RENTAL_TENANTS_SUCCEEDED: 'DO2_GET_PROPERTY_RENTAL_TENANTS_SUCCEEDED',
  DO2_GET_PROPERTY_RENTAL_TENANTS_FAILED: 'DO2_GET_PROPERTY_RENTAL_TENANTS_FAILED',
  doGetPropertyRentalTenants: (values) => ({
    type: propertyActions.DO2_GET_PROPERTY_RENTAL_TENANTS,
    payload: values
  }),
  doGetPropertyRentalTenantsSucceeded: response => ({
    type: propertyActions.DO2_GET_PROPERTY_RENTAL_TENANTS_SUCCEEDED,
    payload: response
  }),
  doGetPropertyRentalTenantsFailed: response => ({
    type: propertyActions.DO2_GET_PROPERTY_RENTAL_TENANTS_FAILED,
    payload: response
  }),

  DO2_ADD_PROPERTY_RENTAL_TENANT: 'DO2_ADD_PROPERTY_RENTAL_TENANT',
  DO2_ADD_PROPERTY_RENTAL_TENANT_SUCCEEDED: 'DO2_ADD_PROPERTY_RENTAL_TENANT_SUCCEEDED',
  DO2_ADD_PROPERTY_RENTAL_TENANT_FAILED: 'DO2_ADD_PROPERTY_RENTAL_TENANT_FAILED',
  doAddPropertyRentalTenant: (values, addRentalDataResponse) => {
    const { propertyHash, rentalDataHash } = addRentalDataResponse.rentalData;
    return ({
      type: propertyActions.DO2_ADD_PROPERTY_RENTAL_TENANT,
      payload: { values, propertyHash, rentalDataHash }
  })},
  doAddPropertyRentalTenantSucceeded: response => ({
    type: propertyActions.DO2_ADD_PROPERTY_RENTAL_TENANT_SUCCEEDED,
    payload: response
  }),
  doAddPropertyRentalTenantFailed: response => ({
    type: propertyActions.DO2_ADD_PROPERTY_RENTAL_TENANT_FAILED,
    payload: response
  }),

  DO2_UPDATE_TENANT_RENTAL_LINK: 'DO2_UPDATE_TENANT_RENTAL_LINK',
  DO2_UPDATE_TENANT_RENTAL_LINK_SUCCEEDED: 'DO2_UPDATE_TENANT_RENTAL_LINK_SUCCEEDED',
  DO2_UPDATE_TENANT_RENTAL_LINK_FAILED: 'DO2_UPDATE_TENANT_RENTAL_LINK_FAILED',
  doUpdateTenantRentalLink: (values, addRentalDataResponse) => {
    const { propertyHash, rentalDataHash } = addRentalDataResponse.rentalData;
    return ({
      type: propertyActions.DO2_UPDATE_TENANT_RENTAL_LINK,
      payload: { values, propertyHash, rentalDataHash }
  })},
  doUpdateTenantRentalLinkSucceeded: response => ({
    type: propertyActions.DO2_UPDATE_TENANT_RENTAL_LINK_SUCCEEDED,
    payload: response
  }),
  doUpdateTenantRentalLinkFailed: response => ({
    type: propertyActions.DO2_UPDATE_TENANT_RENTAL_LINK_FAILED,
    payload: response
  }),

  DO2_REMOVE_PROPERTY_RENTAL_TENANT: 'DO2_REMOVE_PROPERTY_RENTAL_TENANT',
  DO2_REMOVE_PROPERTY_RENTAL_TENANT_SUCCEEDED: 'DO2_REMOVE_PROPERTY_RENTAL_TENANT_SUCCEEDED',
  DO2_REMOVE_PROPERTY_RENTAL_TENANT_FAILED: 'DO2_REMOVE_PROPERTY_RENTAL_TENANT_FAILED',
  doRemovePropertyRentalTenant: (values, addRentalDataResponse) => {
    const { propertyHash, rentalDataHash } = addRentalDataResponse.rentalData;
    return ({
      type: propertyActions.DO2_REMOVE_PROPERTY_RENTAL_TENANT,
      payload: { values, propertyHash, rentalDataHash }
  })},
  doRemovePropertyRentalTenantSucceeded: (response, propertyHash) => ({
    type: propertyActions.DO2_REMOVE_PROPERTY_RENTAL_TENANT_SUCCEEDED,
    payload: response,
    propertyHash
  }),
  doRemovePropertyRentalTenantFailed: response => ({
    type: propertyActions.DO2_REMOVE_PROPERTY_RENTAL_TENANT_FAILED,
    payload: response
  }),

  DO_GET_PROPERTY_SLOT_DATA: 'DO_GET_PROPERTY_SLOT_DATA',
  DO_GET_PROPERTY_SLOT_DATA_SUCCEEDED: 'DO_GET_PROPERTY_SLOT_DATA_SUCCEEDED',
  DO_GET_PROPERTY_SLOT_DATA_FAILED: 'DO_GET_PROPERTY_SLOT_DATA_FAILED',
  doGetPropertySlotData: data => ({
    type: propertyActions.DO_GET_PROPERTY_SLOT_DATA,
    payload: data
  }),
  doGetPropertySlotDataSucceeded: response => ({
    type: propertyActions.DO_GET_PROPERTY_SLOT_DATA_SUCCEEDED,
    payload: response
  }),
  doGetPropertySlotDataFailed: response => ({
    type: propertyActions.DO_GET_PROPERTY_SLOT_DATA_FAILED,
    payload: response
  }),

  DO_GET_ENQUIRY_GRAPH_DATA: 'DO_GET_ENQUIRY_GRAPH_DATA',
  DO_GET_ENQUIRY_GRAPH_DATA_SUCCEEDED: 'DO_GET_ENQUIRY_GRAPH_DATA_SUCCEEDED',
  DO_GET_ENQUIRY_GRAPH_DATA_FAILED: 'DO_GET_ENQUIRY_GRAPH_DATA_FAILED',
  doGetEnquiryGraphData: ({ propertyHash, includeEnquiryTenants = 1 }) => ({
    type: propertyActions.DO_GET_ENQUIRY_GRAPH_DATA,
    payload: { propertyHash, includeEnquiryTenants }
  }),
  doGetEnquiryGraphDataSucceeded: response => ({
    type: propertyActions.DO_GET_ENQUIRY_GRAPH_DATA_SUCCEEDED,
    payload: response
  }),
  doGetEnquiryGraphDataFailed: response => ({
    type: propertyActions.DO_GET_ENQUIRY_GRAPH_DATA_FAILED,
    payload: response
  }),
};

export default propertyActions;



// WEBPACK FOOTER //
// ./src/redux/properties2/actions.js